import { Capacitor } from '@capacitor/core';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { onMounted, onUnmounted, watch } from 'vue';

export function usePhoneLandscapeMode() {
  if (!Capacitor.isPluginAvailable('ScreenOrientation') || !Capacitor.isNativePlatform()) return;
  const isMobile = useBreakpoints(breakpointsTailwind).smallerOrEqual('sm');
  watch(isMobile, () => {
    if (isMobile.value) {
      ScreenOrientation.lock({
        orientation: 'landscape',
      });
    }
  });

  onMounted(() => {
    if (isMobile.value) {
      ScreenOrientation.lock({
        orientation: 'landscape',
      });
    }
  });

  onUnmounted(() => {
    ScreenOrientation.unlock();
  });
}
